import { ExAxios } from '@ExAxios';
import g from '@global';
import axios from 'axios';
/**
 * 获取机构列表
 * @param params{}
 * */
export const fetchOrganList = (params) =>
    new ExAxios((config) =>
        axios.get(
            `${g.getBaseServer()}/manage/organ/organ/findList`,
            {
                ...params,
            },
            {
                ...config,
            },
        ),
    );
/**
 * 获取机构列表
 * @param params{}
 * */
export const fetchOrganTree = (params) =>
    new ExAxios((config) =>
        axios.get(
            `${g.getBaseServer()}/sys/subsys/sysSubSystem/org/findList`,
            {
                ...params,
            },
            {
                ...config,
            },
        ),
    );
/**
 * 获取工程列表
 * @param params{code工程编号,name 工程名称,startInvest 开始金额,endInvest 结束金额}
 * */
export const fetchProjectList = (params) =>
    new ExAxios((config) =>
        axios.get(`${g.getBaseServer()}/disc/project/findList`, {
            params,
            ...config,
        }),
    );

/**
 * 获取工程列表总数
 * @param params{code工程编号,name 工程名称,startInvest 开始金额,endInvest 结束金额page,rows,}
 * */
export const fetchPageTotal = (params) =>
    new ExAxios((config) =>
        axios.get(`${g.getBaseServer()}/disc/project/findPageTotal`, {
            params,
            ...config,
        }),
    );

/**
 * 获取工程列表(分页方式)
 * @param params   params{code工程编号,name 工程名称,startInvest 开始金额,endInvest 结束金额}
 * */
export const fetchProjectPageList = (params) =>
    new ExAxios((config) =>
        axios.get(`${g.getBaseServer()}/disc/project/findPageList`, {
            params,
            ...config,
        }),
    );

/**
 * 获取工程列表(图册模式分页方式)
 * @param params{code工程编号,name 工程名称,startInvest 开始金额,endInvest 结束金额，page,rows,}
 * */
export const fetchProjectPicturePageList = (params) =>
    new ExAxios((config) =>
        axios.get(`${g.getBaseServer()}/disc/project/findPictureList`, {
            params,
            ...config,
        }),
    );

/**
 * 统计工程数量
 * @param params{}
 * */
export const fetchProjectCount = (params) =>
    new ExAxios((config) =>
        axios.get(`${g.getBaseServer()}/disc/project/countProjectInfo`, {
            params,
            ...config,
        }),
    );
/**
 * 统计工程类型数量
 * @param params{}
 * */
export const fetchProjectTypeCount = (params) =>
    new ExAxios((config) =>
        axios.get(`${g.getBaseServer()}/disc/project/countTypeFirst`, {
            params,
            ...config,
        }),
    );

/**
 * 统计无人机巡次数
 * @param params{}
 * */
export const fetchFlyCount = (params) =>
    new ExAxios((config) =>
        axios.get(`${g.getBaseServer()}/disc/project/countFlightSorties`, {
            params,
            ...config,
        }),
    );
/**
 * 统计整改数量
 * @param params{type:}TD:国储土地 GC重大工程 SZ水质 DQ大气TS投诉QT其他
 * */
export const fetchRectifyCount = (params) =>
    new ExAxios((config) =>
        axios.get(`${g.getBaseServer()}/disc/rectify/countRectifyInfo`, {
            params,
            ...config,
        }),
    );
/**
 * 查询整改列表
 * @param params{code 整改编号,type 业务类型,businessId 业务ID} type的值说明TD:国储土地 GC重大工程 SZ水质 DQ大气TS投诉QT其他
 * */
export const fetchRectifyList = (params) =>
    new ExAxios((config) =>
        axios.get(`${g.getBaseServer()}/disc/rectify/findList`, {
            params,
            ...config,
        }),
    );

/**
 * 获取工程里程碑节点
 * @param params   params{projectId 工程id}
 * */
export const fetchProjectStageList = (params) =>
    new ExAxios((config) =>
        axios.get(`${g.getBaseServer()}/disc/stage/findList`, {
            params,
            ...config,
        }),
    );
/**
 * 获取工程里程碑节点(返回数据带图册)
 * @param params   params{projectId 工程id}
 * */
export const fetchProjectStagePicList = (params) =>
    new ExAxios((config) =>
        axios.get(`${g.getBaseServer()}/disc/stage/findStagePicList`, {
            params,
            ...config,
        }),
    );

/**
 * 根据id获取工程详情
 * @param id
 * */
export const fetchDetailById = (id) =>
    new ExAxios((config) =>
        axios.get(`${g.getBaseServer()}/disc/project/getById`, {
            params: {
                id,
            },
            ...config,
        }),
    );
